import { render, staticRenderFns } from "./RunNews.vue?vue&type=template&id=9987a908&scoped=true&"
import script from "./RunNews.vue?vue&type=script&lang=js&"
export * from "./RunNews.vue?vue&type=script&lang=js&"
import style0 from "./RunNews.vue?vue&type=style&index=0&id=9987a908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9987a908",
  null
  
)

export default component.exports